<template>
    <div class="carriers-selector">
        <el-transfer :titles="['Transporteurs disponibles', 'Transporteurs exclues']" :value="value" @input="handleInput" :data="list"></el-transfer>
    </div>
</template>

<script>
export default {
    data() {
        return {
            list: [],
        }
    },
    props: {
        value: {
            type: Array,
            default: []
        }
    },
    mounted() {
        this.fetchData();
    },
    methods: {
        fetchData() {
            axios.get('/carriers')
                .then(response => {
                    this.list = response.data.map(v => {
                        return {
                            key: v.id_reference,
                            label: v.name,
                            disabled: false//v.active == 0
                        }
                    });
                })
                .catch(error => {
                    console.log(error);
                });
        },
        handleInput(value) {
            this.$emit('input', value);
        }
    }
}
</script>
<style lang="scss">
.carriers-selector {
    .el-transfer-panel {
        width: auto;
        min-width: 400px;
    }
}

</style>
